@if(yourMindLogIsActive()){
  <div class="progress-container">
    <span class="last-30">{{ 'historical.last-30' | translate }}</span>
    @if(loadingLogs()){
      <app-loading></app-loading>
    } @else if(chartPoints().length > 1){
      <section class="progress-card">
        <div class="chart-scroll" #chartScroll>
          <div class="chart-shell" [style.width.px]="chartContentWidth()">
            <svg
              class="progress-chart"
              [attr.viewBox]="'0 0 ' + chartContentWidth() + ' 360'"
              role="img"
              [attr.aria-label]="'historical.mood_progress_aria' | translate"
            >
              <defs>
                @for(segment of chartSegments(); track segment.id){
                  <linearGradient
                    [attr.id]="'gradient-' + segment.id"
                    gradientUnits="userSpaceOnUse"
                    [attr.x1]="segment.x1"
                    [attr.y1]="segment.y1"
                    [attr.x2]="segment.x2"
                    [attr.y2]="segment.y2"
                  >
                    <stop offset="0%" [attr.stop-color]="segment.startColor"></stop>
                    <stop offset="100%" [attr.stop-color]="segment.endColor"></stop>
                  </linearGradient>
                }
              </defs>

              @for(segment of chartSegments(); track segment.id){
                <path
                  class="segment"
                  [attr.d]="segment.path"
                  [attr.stroke]="'url(#gradient-' + segment.id + ')'"
                  [attr.stroke-width]="segmentStrokeWidth()"
                  vector-effect="non-scaling-stroke"
                ></path>
              }

              @for(point of chartPoints(); track point.id){
                <g class="mood-marker" [attr.transform]="'translate(' + point.x + ' ' + point.y + ')'">
                  <circle class="marker-glow" [attr.r]="markerGlowRadius()" [attr.fill]="point.backgroundColor"></circle>
                  <circle class="marker-backdrop" [attr.r]="markerSize() / 2 + 3" [attr.fill]="point.color"></circle>
                  <image
                    class="marker-image"
                    [attr.href]="point.image"
                    [attr.x]="-markerSize() / 2"
                    [attr.y]="-markerSize() / 2"
                    [attr.width]="markerSize()"
                    [attr.height]="markerSize()"
                    [attr.aria-label]="point.label | translate"
                  ></image>
                </g>
              }
            </svg>
            <div class="axis">
              @for(point of chartPoints(); track $index){
                <span class="axis-label" [style.left.px]="point.x">
                  <strong>{{ point.dateLabel }}</strong>
                  <small>{{ point.timeLabel }}</small>
                </span>
              }
            </div>
          </div>
        </div>
      </section>
    } @else {
      <div class="empty-state">
        <img src="/imgs/thinking.png" alt="">
        <div>{{ emptyStateKey() | translate }}</div>
      </div>
    }
  </div>
} @else if(sharedWithYouIsActive()){
  <app-users-sharing-logs
    [psychologist]="psychologist()"
    [filterBy]="filterBy()"
    (userSelected)="filterByUser($event)"
  >
  </app-users-sharing-logs>
  <div class="progress-shared-container">
    <span class="last-30 last-30-shared">{{ 'historical.last-30' | translate }}</span>
    @if(loadingSharedLogs()){
      <app-loading></app-loading>
    } @else if(chartPoints().length > 1){
      <section class="progress-card">
        <div class="chart-scroll" #chartScroll>
          <div class="chart-shell" [style.width.px]="chartContentWidth()">
            <svg
              class="progress-chart"
              [attr.viewBox]="'0 0 ' + chartContentWidth() + ' 360'"
              role="img"
              [attr.aria-label]="'historical.mood_progress_aria' | translate"
            >
              <defs>
                @for(segment of chartSegments(); track segment.id){
                  <linearGradient
                    [attr.id]="'gradient-' + segment.id"
                    gradientUnits="userSpaceOnUse"
                    [attr.x1]="segment.x1"
                    [attr.y1]="segment.y1"
                    [attr.x2]="segment.x2"
                    [attr.y2]="segment.y2"
                  >
                    <stop offset="0%" [attr.stop-color]="segment.startColor"></stop>
                    <stop offset="100%" [attr.stop-color]="segment.endColor"></stop>
                  </linearGradient>
                }
              </defs>

              @for(segment of chartSegments(); track segment.id){
                <path
                  class="segment"
                  [attr.d]="segment.path"
                  [attr.stroke]="'url(#gradient-' + segment.id + ')'"
                  [attr.stroke-width]="segmentStrokeWidth()"
                  vector-effect="non-scaling-stroke"
                ></path>
              }

              @for(point of chartPoints(); track point.id){
                <g class="mood-marker" [attr.transform]="'translate(' + point.x + ' ' + point.y + ')'">
                  <circle class="marker-glow" [attr.r]="markerGlowRadius()" [attr.fill]="point.backgroundColor"></circle>
                  <circle class="marker-backdrop" [attr.r]="markerSize() / 2 + 3" [attr.fill]="point.color"></circle>
                  <image
                    class="marker-image"
                    [attr.href]="point.image"
                    [attr.x]="-markerSize() / 2"
                    [attr.y]="-markerSize() / 2"
                    [attr.width]="markerSize()"
                    [attr.height]="markerSize()"
                    [attr.aria-label]="point.label | translate"
                  ></image>
                </g>
              }
            </svg>
            <div class="axis">
              @for(point of chartPoints(); track $index){
                <span class="axis-label" [style.left.px]="point.x">
                  <strong>{{ point.dateLabel }}</strong>
                  <small>{{ point.timeLabel }}</small>
                </span>
              }
            </div>
          </div>
        </div>
      </section>
    } @else {
      <div class="empty-state">
        <img src="/imgs/thinking.png" alt="">
        <div>{{ emptyStateKey() | translate }}</div>
      </div>
    }
  </div>
}
